module.exports = __webpack_public_path__ + "static/media/success.1973a685.svg";